import { all, call } from 'redux-saga/effects';
import { findModule } from 'components/CmsPage/cmsDataToModuleArray';
import * as defaultModuleMap from 'components/CmsPage/modules';

export function* doLoadCmsModules(client, cmsData, moduleMap = defaultModuleMap) {
  const loaders = (cmsData.modules || [])
    .map(moduleDef => [findModule(moduleMap, moduleDef), moduleDef])
    .filter(([module]) => module && module.loadSaga)
    .map(([module, moduleDef]) => call(module.loadSaga, client, moduleDef));

  yield all(loaders);
}
